import { TenantInsights } from '@bioliberty/lifemind';
import { getQueryCacheKey } from '../util';
import { tms } from './tms';

export type ClinicInsights = TenantInsights & {
  [index: string]: number | string | null;
};

interface ClinicsDashboardQueryResult {
  tenantInsights: Record<string, ClinicInsights>;
}

interface ClinicsDashboardQueryParams {
  tenantIds?: string[];
  dateFrom?: string;
  dateTo?: string;
}

const api = tms.injectEndpoints({
  endpoints: (builder) => ({
    getClinicsDashboard: builder.query<ClinicsDashboardQueryResult, ClinicsDashboardQueryParams>({
      query: (params) => ({
        url: `clinics/dashboard`,
        method: 'GET',
        params: {
          ...params,
          tenantIds: params.tenantIds?.join(',')
        }
      }),
      providesTags: (_result, _error, params) => [{ type: 'Clinics', id: getQueryCacheKey(params, 'dashboard') }]
    })
  }),
  overrideExisting: false
});

export const { useGetClinicsDashboardQuery } = api;
